import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";
import * as fromActions from "./service.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./service.graphql";
import {SubmitResubmitEnum} from "../../../../interfaces/global.interface";
import {upsertApprovedService} from "../approved-service/approved-service.actions";
import {getPopsmggApprovalServices} from "./service.actions";
import {PaginationService} from "../../../../services/pagination.service";
import {
  GET_SERVICES_AT_MY_ROSTER,
  POPSMGG_SUBMIT_RESUBMIT_SERVICE_ACTION,
  ROSTER_SUBMIT_RESUBMIT_SERVICE_ACTION
} from "./service.graphql";
import {Router} from "@angular/router";


@Injectable()
export class ServiceEffects {


  createService$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createService),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_INSTITUTION_SERVICE,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertService({ service: result?.data }));
              this.notificationService.successMessage('Created Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateService$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editService),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_INSTITUTION_SERVICE,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertService({ service: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteService$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeService),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_INSTITUTION_SERVICE,
        variables: {
          serviceUniqueId: action?.serviceUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteService({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getAllServices$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllService),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_INSTITUTION_SERVICE,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServices({ services: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  getPopsmggApprovalServices$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getPopsmggApprovalServices),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_POPSMGG_APPROVAL_SERVICES,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]

            if (result?.response?.status) {
              this.paginationService.setPage({...result?.page, itemsPerPage: 10})
              this.store.dispatch(fromActions.loadServices({services: result?.data}))
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServicesAtMyRoster$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServicesAtMyRoster),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_SERVICES_AT_MY_ROSTER,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]

            if (result?.response?.status) {
              this.paginationService.setPage({...result?.page, itemsPerPage: 10})
              this.store.dispatch(fromActions.loadServices({services: result?.data}))
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getNotApprovedServices$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getNotApprovedServices),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_NOT_APPROVED_INSTITUTION_SERVICES,
        fetchPolicy: 'network-only',
        variables: {
          profileUniqueId: action.profileUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            console.log(result)
            result?.response?.status ? this.store.dispatch(fromActions.loadServices({ services: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });


  getServiceApprovalRequests$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceApprovalRequests),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_POPSM_INSTITUTION_SERVICES,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServices({ services: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });


  approvalService$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.submitResubmitServiceApproval),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: action?.input?.approvalLevel === 'INSTITUTION' ?
          fromGraphql.SUBMIT_RESUBMIT_SERVICE_APPROVAL_ACTION :
          fromGraphql.POPSMGG_SUBMIT_RESUBMIT_SERVICE_ACTION,
        variables: {
          input: action?.input?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertService({ service: result?.data }));
              this.store.dispatch(upsertApprovedService({ approvedService : result?.data }));

              action.input?.input?.approvalServiceDirection === SubmitResubmitEnum.SUBMIT ?
              this.notificationService.successMessage('Submitted Successfully ')
              :
              this.notificationService.successMessage('Resubmitted Successfully ');

              if (action?.input?.approvalLevel === 'POPSMGG') {
                this.router.navigateByUrl('/service-management/service-approval-requests')
              } else {
                this.router.navigateByUrl('/service-management/service-list')
              }
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  rosterApprovalService$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.rosterSubmitResubmitServiceApproval),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: ROSTER_SUBMIT_RESUBMIT_SERVICE_ACTION,
        variables: {
          input: action?.input?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertService({ service: result?.data }));
              this.store.dispatch(upsertApprovedService({ approvedService : result?.data }));

              action.input?.input?.approvalServiceDirection === SubmitResubmitEnum.SUBMIT ?
              this.notificationService.successMessage('Submitted Successfully ')
              :
              this.notificationService.successMessage('Resubmitted Successfully ');

              this.router.navigateByUrl('/service-management/service-approval-my-roster')

            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  approvalServicePopsm$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.serviceApprovalPopsm),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.APPROVE_SERVICE_ACTION,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertService({ service: result?.data }));
              this.store.dispatch(upsertApprovedService({ approvedService: result?.data }))
              await this.notificationService.successMessage(`${ action.input.serviceIsApproved ? 'Approved' : 'Disapproved'} Successfully`)
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  reviewServicePopsm$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.serviceReviewPopsm),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.POPSMGG_REVIEW_SERVICE_ACTION,
        variables: {
          input: {
            serviceUniqueId: action?.input?.serviceUniqueId,
          }
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              this.store.dispatch(fromActions.upsertService({ service: result?.data }));
              this.store.dispatch(upsertApprovedService({ approvedService: result?.data }))
              await this.notificationService.successMessage(`Reviewed Successfully`)
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });
  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private paginationService: PaginationService,
    private router: Router
  ) {}
}
